import React, { useRef, useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './iceaDatePickerTheme.css';
import IceaDatePickerHeader, { getYearRangeStart, YEAR_GRID_SIZE } from './IceaDatePickerHeader';
import { clampYearRangeStart } from './datePickerBounds';

export default function IceaDatePicker({
  selected,
  onChange,
  onBlur,
  minDate,
  maxDate,
  dateFormat = 'yyyy-MM-dd',
  placeholderText = 'Select Date',
  inputClassName = 'form-input',
  onChangeRaw,
}) {
  const [view, setView] = useState('day');
  const [yearRangeStart, setYearRangeStart] = useState(getYearRangeStart(new Date().getFullYear()));
  const layoutCalendarId = useRef(`icea-cal-${Math.random().toString(36).slice(2)}`).current;
  const datePickerRef = useRef(null);

  const syncYearPage = (referenceDate) => {
    const referenceYear = referenceDate instanceof Date && !Number.isNaN(referenceDate.getTime())
      ? referenceDate.getFullYear()
      : new Date().getFullYear();
    const start = getYearRangeStart(referenceYear);
    setYearRangeStart(clampYearRangeStart(start, minDate, maxDate, YEAR_GRID_SIZE));
  };

  const openCalendar = () => {
    setView('day');
    syncYearPage(selected || minDate || maxDate || new Date());
    datePickerRef.current?.setOpen(true);
  };

  return (
    <div className="datepickerCustom">
      <DatePicker
        ref={datePickerRef}
        selected={selected}
        onChange={onChange}
        onBlur={onBlur}
        minDate={minDate}
        maxDate={maxDate}
        dateFormat={dateFormat}
        placeholderText={placeholderText}
        className={inputClassName}
        onCalendarOpen={openCalendar}
        onCalendarClose={() => setView('day')}
        onChangeRaw={onChangeRaw}
        calendarClassName={`icea-datepicker icea-datepicker--${view} ${layoutCalendarId}`}
        popperClassName="icea-datepicker-popper"
        renderCustomHeader={(headerProps) => (
          <IceaDatePickerHeader
            {...headerProps}
            view={view}
            setView={(nextView) => {
              if (nextView === 'year') {
                syncYearPage(headerProps.date);
              }
              setView(nextView);
            }}
            yearRangeStart={yearRangeStart}
            setYearRangeStart={setYearRangeStart}
            minDate={minDate}
            maxDate={maxDate}
          />
        )}
      />
    </div>
  );
}
